module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conflitos-detalhe"
  }, [(_vm.item && _vm.item.log_erro && _vm.item.log_erro.length) ? _c('div', {
    staticClass: "conflitos-detalhe__section"
  }, [_c('div', {
    staticClass: "conflitos-detalhe__title conflitos-detalhe__title--erro"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Erro (" + _vm._s(_vm.item.log_erro.length) + ")\n    ")]), _vm._v(" "), _vm._l((_vm.item.log_erro), function(err, key) {
    return _c('div', {
      key: 'erro-' + key,
      staticClass: "conflitos-detalhe__item conflitos-detalhe__item--erro"
    }, [(err['risco_vinculo']) ? _c('span', [_vm._m(0, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú Configurações > Riscos para atualizar corretamente os riscos abaixo.")]), _vm._v(" "), _vm._l((err['risco_vinculo']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(risco))])
    })], 2) : (err['exame_vinculo']) ? _c('span', [_vm._m(1, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú Configurações > Exames para atualizar corretamente os exames abaixo.")]), _vm._v(" "), _vm._l((err['exame_vinculo']), function(exame, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(exame))])
    })], 2) : (err['cadastro_medico']) ? _c('span', [_vm._m(2, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú Configurações > Médicos Examinadores para atualizar corretamente o médico da consulta.")]), _vm._v(" "), _vm._l((err['cadastro_medico']), function(exame, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(exame))])
    })], 2) : (err['cadastro_funcionario']) ? _c('span', [_vm._m(3, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú Empresa > Funcionários para atualizar corretamente os dados do trabalhador.")]), _vm._v(" "), _vm._l((err['cadastro_funcionario']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(risco))])
    })], 2) : (err['cadastro_reg_amb']) ? _c('span', [_vm._m(4, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú PPRA/PGR > Gerenciar para atualizar corretamente os dados do responsável pelo PGR.")]), _vm._v(" "), _vm._l((err['cadastro_reg_amb']), function(posicoes, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [(posicoes.posicao) ? _c('b', [_vm._v(_vm._s(posicoes.posicao) + ":")]) : _vm._e(), _vm._v(" "), (posicoes.msg) ? _c('span', [_vm._v(_vm._s(posicoes.msg))]) : _c('span', [_vm._v(_vm._s(posicoes))])])
    })], 2) : (err['cadastro_ppp_fdt']) ? _c('span', [_vm._m(5, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú LTCAT > Gerenciar para atualizar corretamente as medições do LTCAT desse trabalhador.")]), _vm._v(" "), _vm._l((err['cadastro_ppp_fdt']), function(posicoes, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [(posicoes.msg) ? _c('span', [_vm._v(_vm._s(posicoes.msg))]) : _c('span', [_vm._v(_vm._s(posicoes))])])
    })], 2) : (err['erro_cadastro_fdt']) ? _c('span', [_vm._m(6, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú Empresa > Editar > Frente de Trabalho > Editar para atualizar corretamente a frente de trabalho.")]), _vm._v(" "), _vm._l((err['erro_cadastro_fdt']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(risco))])
    })], 2) : (err['cadastro_sem_risco']) ? _c('span', [_vm._m(7, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú PCMSO > Gerenciar para atualizar corretamente o documento PPRA ou PCMSO.")]), _vm._v(" "), _vm._l((err['cadastro_sem_risco']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(risco))])
    })], 2) : (err['error_cadastro_epi']) ? _c('span', [_vm._m(8, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú LTCAT > Gerenciar para atualizar corretamente as medições no documento.")]), _vm._v(" "), _vm._l((err['error_cadastro_epi']), function(epis, i) {
      return [_c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_c('b', [_vm._v(_vm._s(i))])]), _vm._v(" "), _vm._l((epis), function(epi) {
        return _c('p', {
          key: epi,
          staticClass: "conflitos-detalhe__line"
        }, [_vm._v(_vm._s(epi))])
      })]
    })], 2) : (err['cadastro']) ? _c('span', [_vm._m(9, true), _vm._v(" "), _vm._l((err['cadastro']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(risco))])
    })], 2) : (err['cadastro_abs']) ? _c('span', [_vm._m(10, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú Absenteísmo > Gerenciar para atualizar corretamente o registro que está com erro.")]), _vm._v(" "), _vm._l((err['cadastro_abs']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(risco))])
    })], 2) : (err['erro_cadastro_setor']) ? _c('span', [_vm._m(11, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú PPRA/PGR > Gerenciar para atualizar corretamente o GHE (Setor) em questão.")]), _vm._v(" "), _vm._l((err['erro_cadastro_setor']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(risco))])
    })], 2) : (err['erro_cadastro_atividade_funcao']) ? _c('span', [_vm._m(12, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú PPRA/PGR > Gerenciar, selecione o GHE (Setor) indicado e preencha a descrição de atividades da função do trabalhador.")]), _vm._v(" "), _vm._l((err['erro_cadastro_atividade_funcao']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v(_vm._s(risco))])
    })], 2) : (err['erro_cadastro_fator_risco']) ? _c('span', [_vm._m(13, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú Configurações > Fatores de Risco para preencher a descrição da metodologia do fator de risco indicado.")]), _vm._v(" "), _vm._l((err['erro_cadastro_fator_risco']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v("\n          " + _vm._s(risco.msg ? risco.msg : risco) + "\n        ")])
    })], 2) : (err['erro_cadastro_epi_risco']) ? _c('span', [_vm._m(14, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú PPRA/PGR > Gerenciar, selecione o GHE (Setor) e vincule um ou mais EPIs ao risco indicado.")]), _vm._v(" "), _vm._l((err['erro_cadastro_epi_risco']), function(risco, i) {
      return _c('p', {
        key: i,
        staticClass: "conflitos-detalhe__line"
      }, [_vm._v("\n          " + _vm._s(risco.msg ? risco.msg : risco) + "\n        ")])
    })], 2) : (err['erro_cadastro_reg_amb']) ? _c('span', [_vm._m(15, true), _vm._v(" "), _c('p', {
      staticClass: "conflitos-detalhe__path"
    }, [_vm._v("Acesse o menú Ltcat > Gerenciar para atualizar corretamente as medições do GHE (Setor) do funcionário em questão.")])]) : _c('span', [_c('p', {
      staticClass: "conflitos-detalhe__line"
    }, [_vm._v(_vm._s(err))])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.item && _vm.item.log_warning && _vm.item.log_warning.length) ? _c('div', {
    staticClass: "conflitos-detalhe__section"
  }, [_c('div', {
    staticClass: "conflitos-detalhe__title conflitos-detalhe__title--warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Pontos de Atenção (" + _vm._s(_vm.item.log_warning.length) + ")\n    ")]), _vm._v(" "), _vm._l((_vm.item.log_warning), function(warn, key) {
    return _c('div', {
      key: 'warn-' + key,
      staticClass: "conflitos-detalhe__item conflitos-detalhe__item--warning"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(warn)
      }
    })])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.hasContent) ? _c('div', {
    staticClass: "conflitos-detalhe__empty"
  }, [_vm._v("Nenhum conflito encontrado.")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("RISCO SEM VÍNCULO COM ESOCIAL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("EXAME SEM VÍNCULO COM ESOCIAL OU COM PROBLEMA DE CADASTRO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("CADASTRO DO MÉDICO EXAMINADOR INVÁLIDO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("CADASTRO DO TRABALHADOR INVÁLIDO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("CADASTRO RESPONSÁVEL TÉCNICO INVÁLIDO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("CADASTRO DA EXPOSIÇÃO A FATORES DE RISCOS INVÁLIDO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("CADASTRO DA FRENTE DE TRABALHO INVÁLIDO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("NENHUM RISCO FOI ENCONTRADO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("EPI CADASTRADO INCORRETAMENTE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("CADASTRO INVÁLIDO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("CADASTRO DO ABSENTEÍSMO INVÁLIDO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("CADASTRO DO GHE (SETOR) INCORRETO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("DESCRIÇÃO DE ATIVIDADES DA FUNÇÃO NÃO INFORMADA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("FATOR DE RISCO SEM DESCRIÇÃO DA METODOLOGIA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("EPI NÃO CADASTRADO PARA O RISCO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "conflitos-detalhe__hint"
  }, [_c('b', [_vm._v("NENHUMA MEDIÇÃO FOI CADASTRADO PARA ESSE LTCAT")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7aed02ed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/includes/conflitos-detalhe.vue
// module id = 1551
// module chunks = 45